( function( $ ) {
    $(document).ready(function () {
        $('.js-accordion').each(function () {
            const $accordion = $(this);
            const $toggleAccordion = $accordion.find('.js-toggleAccordion');
            const closeOthers = $accordion.data('close-others') !== false;

            $toggleAccordion.on('click', function() {
                const $accordionContent = $(this).next('.js-accordionContent');
                if (closeOthers) {
                    $accordion.find('.js-accordionContent').not($accordionContent).slideUp();
                    $accordion.find('.js-toggleAccordion').not(this).removeClass('-active');
                }
                $accordionContent.slideToggle();
                $(this).toggleClass('-active');
            });
        });

        // Open the question a URL points to, e.g. /veelgestelde-vragen/#faq-123
        if (/^#faq-\d+$/.test(window.location.hash)) {
            const $item = $(window.location.hash);
            if ($item.length) {
                $item.find('.js-toggleAccordion').first().trigger('click');

                // The browser's own jump to the anchor doesn't happen here, so jump to it once the
                // page has fully loaded, keeping the question clear of the fixed header
                $(window).on('load', function () {
                    const headerHeight = $('.js-header').outerHeight() || 0;
                    window.scrollTo({ top: $item.offset().top - headerHeight - 40, behavior: 'instant' });
                });
            }
        }
    });
} ) ( jQuery );